import { Organization } from "./Organization";

export class OrganizationPaginated {
  constructor() {
    this.organizationCount = 0;
    this.organizationData = [];
    this.shouldOrgListUpdate = true;
  }

  /**
   * @type {number}
   */
  organizationCount;
  /**
   * @type {boolean}
   */
  shouldOrgListUpdate;

  /**
   * @type {Organization[]}
   */
  organizationData;
}
